<template>
    <v-textarea
        v-if="isEditable"
        ref="text-area"
        key="enable"
        v-model="text"
        class="text-body-2 ma-0 pa-0 text-area"
        :rules="rulesData"
        :disabled="isDisabled"
        :hint="isHint"
        :placeholder="placeholderData"
        :append-icon="appendIconData"
        :rows="rows"
        :label="label"
        :readonly="isReadOnly"
        persistent-hint
    />
    <v-flex v-else key="disable" class="label-for-input-form text-caption pa-0">
        <label>{{ text }}</label>
    </v-flex>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'TextAreaLabel',
})
export default class TextAreaLabel extends Vue {
    @Prop({ default: '' }) value: string;
    @Prop({ default: true }) editable: boolean;
    @Prop({ default: [] }) rules: Array<any>;
    @Prop({ default: '' }) placeholder: string;
    @Prop({ default: '' }) appendIcon: string;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: '' }) hint: string;
    @Prop({ default: 5 }) rows: number;
    @Prop({ default: '' }) label: string;
    @Prop({ default: false }) readonly isReadOnly: boolean;
    @Watch('value', { immediate: true })
    onValueChanged(val: string): void {
        this.text = val;
    }
    @Watch('text')
    onTextChanged(val: string): void {
        this.$emit('input', val);
    }

    text = '';

    get isEditable(): boolean {
        return this.editable;
    }
    get rulesData(): Array<any> {
        return this.rules;
    }
    get placeholderData(): string {
        return this.placeholder;
    }
    get appendIconData(): string {
        return this.appendIcon;
    }
    get isDisabled(): boolean {
        return this.disabled;
    }
    get isHint(): string {
        return this.hint;
    }
    reset(): void {
        (this as any).$refs['text-area'].reset();
    }
}
</script>

<style lang="scss" scoped>
/*IE11でヒントを表示すると見切れるため*/
.text-area :deep(.v-messages__message) {
    transition: none;
    line-height: 15px;
}
</style>
